import { queryOptions } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getUserToWorkspaces } from "@/api/resources/usersToWorkspaces/api";
import i18n from "@/providers/i18n";

const entities = i18n.t("users");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const usersToWorkspacesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "users_to_workspaces"],
  listByUserId: (user_id?: string) => [...usersToWorkspacesQueryKeys.all(), "byUserId", user_id],
};

export const usersToWorkspacesQueries = {
  listByUserId: (user_id?: string) =>
    queryOptions({
      queryKey: [...usersToWorkspacesQueryKeys.listByUserId(user_id)],
      queryFn: () => getUserToWorkspaces(user_id ?? ""),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
};
